import * as React from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core";
import NftMintInput from "../NftMintInput";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    borderRadius: "18px",
    background: "#fff",
    borderColor: "#F0B90B",
    borderWidth: "2px",
  },
  alertCard: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
}));

export default function NftMintCard({ erc20 }) {
  const { cardRoot, alertCard } = useStyles();
  const [open, setOpen] = React.useState(false);
  const [tx, setTx] = React.useState(null);
  const handleData = (data) => {
    console.log("tx in nftMintCard", data);
    setTx(data);
    setOpen(true);
  };
  return (
    <>
      {tx ? (
        <div className={alertCard}>
          <Collapse in={open}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
             Transaction hash : 
              {tx}
              <br />
              <a
                href={`https://goerli.etherscan.io/tx/${tx}`}
                target="_blank"
                rel="noreferrer"
              >
                Click here to verify contract
              </a>
            </Alert>
          </Collapse>
        </div>
      ) : null}

      <Box sx={{ minWidth: 325 }}>
        <Card className={cardRoot} variant="outlined">
          <CardContent>
              <NftMintInput onSelect={handleData} />
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
